import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=ea3001e6"
import script from "./BaseIconButton.vue?vue&type=script&lang=ts"
export * from "./BaseIconButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports